<template>
	<div :class="$style.notification">
		<BaseTooltip
			v-if="notification.timestamp"
			position="right"
			:content="date"
		>
			<TimeAgo
				:class="[$style['color'],$style['color--grey']]"
				:timestamp="timestamp"
			/>
		</BaseTooltip>
		<p :class="$style['notification__title']" class="notification__title">
			{{ $t(`notifications.types.confirm-pictures-upload.title`) }}
		</p>
		<p
			v-if="notification?.totalOperations > 1"
			:class="$style['notification__notice']"
		>
			{{ $t('notifications.types.data-export.finished-updating') }}: <strong :class="$style['color--success']">{{ notification.totalOperations }}</strong>
		</p>
		<div
			v-if="notification.partId"
			:class="$style['notification__buttons']"
		>
			<button
				:class="$style['notification__button']"
				@click="handleClickLink"
			>
				<BaseRipple />
				{{ $t('common.actions.view') }}
			</button>
		</div>
	</div>
</template>

<script>
import { faLongArrowRight } from '@fortawesome/pro-light-svg-icons'
import moment from '@/packages/moment'
import TimeAgo from '@/components/Essentials/TimeAgo'
export default {
	name: 'ConfirmPartPicturesUploadNotification',
	components: {
		TimeAgo
	},
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	data () {
		return {
			icons: {
				faLongArrowRight
			}
		}
	},
	computed: {


		date () {
			if (this.notification.timestamp) {

				return moment(this.notification.timestamp).format('LLLL')
			}
			return null
		},
		timestamp () {
			if (this.notification.timestamp) {

				return new Date(this.notification.timestamp).getTime()
			}
			return null
		}
	},
	methods: {

		async handleClickLink () {
			sessionStorage.setItem('draftsFilters', JSON.stringify([
				{
					key: 'id',
					name: `ID: #${this.notification.partId}`,
					value: this.notification.partId,
					id: this.notification.partId
				}
			]))
			await this.$router.push({ name: 'Dashboard:PartsDrafts' }).catch(_err => {})
		}

	}
}
</script>
<style lang="scss" module>
.color {
    font-size: 12px;

    &--grey {
        color: getColor(caption);
    }

    &--primary {
        color: getColor(primary);
    }

    &--success {
        color: getColor(success);
    }

    &--danger {
        color: getColor(danger);
    }
}

.notification {
    font-size: 14px;

    &__title {
        margin: 0;
        font-size: 16px;
        margin-bottom: 5px;
        margin-top: 5px;
    }

    &__notice {
        margin: 0;
        margin-bottom: 10px;
        font-size: 14px;
    }

    &__button {
        display: flex;
        align-items: center;
        appearance: none;
        border: 0;
        font-size: 14px;
        border-radius: 4px;
        color: getColor(primary);
        text-decoration: none;
        padding: $gutter $gutter * 2;
        cursor: pointer;
        position: relative;
        overflow: hidden;
        background-color: getColor(surface-secondary);

        &:hover {
            cursor: pointer;
            background-color: getColor(primary-soft);
            color: getColor(primary-strong);
        }

        &:active,
        &:focus {
            outline: 0;
        }

        &:nth-child(2) {
            margin-left: 10px;
        }

        &--danger {
            color: getColor(danger);
            background-color: getColor(surface-secondary);
            border: none;

            &:hover {
                cursor: pointer;
                background-color: getColor(danger-soft);
                color: getColor(danger-strong);
            }
        }
    }

    &__button-icon {
        margin-left: 7.5px;
        font-size: 16px;
    }
}
</style>
